export default __webpack_public_path__ + "static/media/print_bill_lite.0e594628.svg";